module.exports = "/fonts/feather.eot?931c9e74d0b20947054bfe6a5b74a838";